export const PUBLIC_DOCS_URL = "https://docs.emite.do";

const HASH_PATHS: Record<string, string> = {
  "cargar-p12": "/guides/company",
  "rangos-ncf": "/guides/company",
  "post-ecf": "/guides/first-document",
};

/** Destino canónico en docs.emite.do. Acepta path (`/changelog`) o hash viejo (`#cargar-p12`). */
export function publicDocsUrl(pathOrHash = ""): string {
  if (!pathOrHash || pathOrHash === "/docs") {
    return PUBLIC_DOCS_URL;
  }
  if (pathOrHash.startsWith("#")) {
    const mapped = HASH_PATHS[pathOrHash.slice(1)];
    return mapped ? `${PUBLIC_DOCS_URL}${mapped}` : PUBLIC_DOCS_URL;
  }
  const path = pathOrHash.startsWith("/") ? pathOrHash : `/${pathOrHash}`;
  return `${PUBLIC_DOCS_URL}${path}`;
}
